<!--<ipos-sidebar></ipos-sidebar>-->
<article>
  <div class="header bg-white">
    <div class="container-fluid">
      <div class="header-body">
        <div class="row align-items-center py-3 bg-head-light mb-2">
          <div class="col-lg-6 col-5">
            <h1 style="justify-content: center;" class="h3 mb-0">Merchant Accessories Request</h1>
          </div>
          <div class="col-lg-6 col-7 text-right">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4 float-right">
              <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                <li class="breadcrumb-item">
                  <i class="fas fa-home"></i>
                </li>
                <li class="breadcrumb-item"><a routerLink="/dashboard">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  Support Request
                </li>
              </ol>
            </nav>
            <!-- <div class="container">
              <div>
                <input type="file" class="form-control" (change)="addfile($event)" placeholder="Upload file" id="file"
                  accept=".xslx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                <br>
                <button class="btn btn-primary" (click)="export()">Click to download Upload Format</button>
              </div>
            </div>
            <br> -->
            <input type="text" (keyup)="onQuickFilterChanged()" class="form-control"
            [(ngModel)]="quickSearchValue" placeholder="search..." /><i class="fa fa-search"></i>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- <h1 style="justify-content: flex; text-align: center; color: indianred;">Support </h1> -->
  <div class="p-3">
    <ag-grid-angular
                    style=" height: 500px;"
                    class="ag-theme-alpine"
                    [enableSorting]="true"
                    [enableFilter]="true"
                    [rowData]="rows"
                    [enableCellTextSelection]="true"
                    [rowHeight]="40"
                    [enableCellTextSelection]="true"
                    [pagination]="true"
                    [columnDefs]="columnDefs"
                    (gridReady)="onGridReady($event)"
                    (rowClicked)="onRowClicked($event)">
    </ag-grid-angular>

    <!-- <div class="modal " id="myModal" [style.display]="addAccessories ? 'block' : 'none'">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #7146EB !important;color:white">
            <h4 style="text-align:center !important; color:white;">New Accessories Request</h4>
            <button type="button" class="close" data-dismiss="modal" (click)="hide()"><i
                class="fa fa-times"></i></button>
          </div>
          <div class="modal-body clearfix" style="padding: 0;">
            <div class="form-group has-feedback">
              <form [formGroup]="accessoriesForm" (ngSubmit)="onRequest()">
                <div class="form-group">
                  <div class="form-group-content">
                    <div class="row">

                      <div class=" col-md-4">
                        <label class="control-label" for="MerchantName">Merchant Name</label>
                        <p>{{editRow.merchant}}</p>
                      </div>
                      <div class=" col-md-4">
                        <label class="control-label" for="MerchantId">Merchant Id</label>
                        <p>{{editRow.idMerchant}}</p>
                      </div>
                      <div class="col-md-4">

                        <label class="control-label" for="TerminalId">Terminal Id</label>
                        <p>{{editRow.idTerminal}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <label class="control-label" for="TerminalType">Terminal Type</label>
                        <p>{{editRow.item}}</p>
                      </div>
                      <div class=" col-md-4">
                        <label class="control-label" for="SerialKey">Serial Key</label>
                        <p>{{editRow.serialKey}}</p>
                      </div>
                      <div class="col-md-4">
                        <label class="control-label" for="Connectivity">Connectivity</label>
                        <p>{{editRow.connectivity}}</p>
                      </div>

                    </div>

                  </div>

                  <div class="col-md-12 content-padding">
                    <div class="row">
                      <div class="form-group col-md-6">

                        <label class="col-sm-8"> Accessories Types <sup class="required-sign">*</sup></label>

                        <select formControlName="InventoryId" class="form-control col-sm-6" name="inventoryId"
                          id="InventoryId" class="form-control "
                          [ngClass]="{ 'is-invalid': submitted && f.InventoryId.errors }" required>
                          <option *ngFor="let inventory of rows" [value]="inventory.id"
                            (click)="InventoryId = inventory.id;" class="drop">
                            <span>
                              {{ inventory.primaryItem }} &nbsp;&nbsp; {{ inventory.tertiaryItem }} &nbsp;&nbsp; {{
                              inventory.detailItem }} &nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                          </option>
                        </select>
                        <div *ngIf="submitted && f.InventoryId.errors" class="invalid-feedback">
                          <div *ngIf="f.InventoryId.errors.required">Accessories Type is required</div>
                        </div>

                      </div>
                      <div class="form-group col-md-12">
                        <label class="col-md-4">Branch Name<sup class="required-sign">*</sup></label>
                        <div class="col-md-8">
                          <ng-autocomplete [data]="bankBranches" [searchKeyword]="keyword"
                            placeholder="Enter the Branch Name" (selected)='bankBranchselectEvent($event)'
                            (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)'
                            [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"
                            [ngClass]="{'is-invalid invalid-autocomplete': submitted && f.location.errors }">
                          </ng-autocomplete>

                          <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                            <div *ngIf="f.location.errors.required"> Branch Name is required</div>
                          </div>
                          <ng-template #itemTemplate let-item>
                            <a [innerHTML]="item.branchName"> </a>
                          </ng-template>

                          <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound"></div>
                          </ng-template>

                        </div>
                      </div>
                      <div class="form-group col-md-12">
                        <label class="col-lg-8">Quantity <sup class="required-sign">*</sup></label>
                        <input type="number" class="form-control col-sm-" min="1" max="9999" maxlength="4"
                          oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 1) ? (1/0) : this.value;"
                          name="requested_Quantity" id="requested_Quantity" placeholder="Enter requested Quantity"
                          formControlName="requested_Quantity" class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.requested_Quantity.errors }" required>
                        <div *ngIf="submitted && f.requested_Quantity.errors" class="invalid-feedback">
                          <div *ngIf="f.requested_Quantity.errors.required">Quantity is required</div>
                        </div>

                      </div>
                    </div>

                  </div>

                  <div class="form-group col-md-12">
                    <button *ngIf="!isUpdating" class="btn btn-neutral" type="submit">
                      <span class="spinner-border spinner-border-sm mr-1"></span>
                      Submit Request
                    </button>
                    <button *ngIf="isUpdating" class="btn btn-neutral" type="submit">
                      <span class="spinner-border spinner-border-sm mr-1"></span>
                      Update Request
                    </button>
                  </div>

                </div>

              </form>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="modal " id="myModal" [style.display]="editAccessories ? 'block' : 'none'">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #7146EB !important;color:white">
            <h4 style="text-align:center !important; color:white;">Update Accessories Request</h4>
            <button type="button" class="close" data-dismiss="modal" (click)="hide()"><i
                class="fa fa-times"></i></button>
          </div>
          <div class="modal-body clearfix" style="padding: 0;">
            <div class="form-group has-feedback">
              <form [formGroup]="SupportForm" (ngSubmit)="onRequest()">
                <div class="form-group">
                  <div class="form-group-content">
                    <div class="row">

                      <div class=" col-md-4">
                        <label class="control-label" for="MerchantName">Merchant Name</label>
                        <p>{{editRow.merchant}}</p>
                      </div>
                      <div class=" col-md-4">
                        <label class="control-label" for="MerchantId">Merchant Id</label>
                        <p>{{editRow.idMerchant}}</p>
                      </div>
                      <div class="col-md-4">

                        <label class="control-label" for="TerminalId">Terminal Id</label>
                        <p>{{editRow.idTerminal}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <label class="control-label" for="TerminalType">Terminal Type</label>
                        <p>{{editRow.item}}</p>
                      </div>
                      <div class=" col-md-4">
                        <label class="control-label" for="SerialKey">Serial Key</label>
                        <p>{{editRow.serialKey}}</p>
                      </div>
                      <div class="col-md-4">
                        <label class="control-label" for="Connectivity">Connectivity</label>
                        <p>{{editRow.connectivity}}</p>
                      </div>

                    </div>

                  </div>

                  <div class="col-md-12 content-padding">
                    <div class="row">
                      <div class="form-group col-md-6">

                        <label class="col-sm-8"> Accessories Types <sup class="required-sign">*</sup></label>

                        <select formControlName="InventoryId" class="form-control col-sm-6" name="inventoryId"
                          id="InventoryId" class="form-control "
                          [ngClass]="{ 'is-invalid': submitted && f.InventoryId.errors }" required>
                          <option *ngFor="let inventory of rows" [value]="inventory.id"
                            (click)="InventoryId = inventory.id;" class="drop">
                            <span>
                              {{ inventory.primaryItem }} &nbsp;&nbsp; {{ inventory.tertiaryItem }} &nbsp;&nbsp; {{
                              inventory.detailItem }} &nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                          </option>
                        </select>
                        <div *ngIf="submitted && f.InventoryId.errors" class="invalid-feedback">
                          <div *ngIf="f.InventoryId.errors.required">Accessories Type is required</div>
                        </div>

                      </div>
                      <div class="form-group col-md-12">
                        <label class="col-md-4">Branch Name<sup class="required-sign">*</sup></label>
                        <div class="col-md-8">
                          <ng-autocomplete [data]="bankBranches" [searchKeyword]="keyword"
                            placeholder="Enter the Branch Name" (selected)='bankBranchselectEvent($event)'
                            (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)'
                            [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"
                            [ngClass]="{'is-invalid invalid-autocomplete': submitted && f.location.errors }">
                          </ng-autocomplete>

                          <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                            <div *ngIf="f.location.errors.required"> Branch Name is required</div>
                          </div>
                          <ng-template #itemTemplate let-item>
                            <a [innerHTML]="item.branchName"> </a>
                          </ng-template>

                          <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound"></div>
                          </ng-template>

                        </div>
                      </div>
                      <div class="form-group col-md-12">
                        <label class="col-lg-8">Quantity <sup class="required-sign">*</sup></label>
                        <input type="number" class="form-control col-sm-" min="1" max="9999" maxlength="4"
                          oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 1) ? (1/0) : this.value;"
                          name="requested_Quantity" id="requested_Quantity" placeholder="Enter requested Quantity"
                          formControlName="requested_Quantity" class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.requested_Quantity.errors }" required>
                        <div *ngIf="submitted && f.requested_Quantity.errors" class="invalid-feedback">
                          <div *ngIf="f.requested_Quantity.errors.required">Quantity is required</div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>

                <div class="form-group col-md-12">
                  <button *ngIf="!isUpdating" class="btn btn-neutral" type="submit">
                    <span class="spinner-border spinner-border-sm mr-1"></span>
                    Submit Request
                  </button>
                  <button *ngIf="isUpdating" class="btn btn-neutral" type="submit">
                    <span class="spinner-border spinner-border-sm mr-1"></span>
                    Update Request
                  </button>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </div> -->

    <div class="modal" id="myModal" [style.display]="showModelBox ? 'block' : 'none'">
      <div class="modal-dialog modal-lg" style="height: 500px  !important;">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #7146EB !important;color:white">
            <h3 *ngIf="!isUpdating" style="text-align:center !important; color:white;">New Accessories Request</h3>
            <!-- <h3 *ngIf="isUpdating" style="text-align:center !important; color:white;">Update Accessories Request</h3> -->
            <button type="button" class="close" data-dismiss="modal" (click)="hide()"><i
                class="fa fa-times"></i></button>
          </div>
          <div class="modal-body">
            <form [formGroup]="accessoriesForm" (ngSubmit)="onRequest()">
              <div class="form-group">
                  <div class="form-group-content">
                    <div class="row">

                      <div class=" col-md-4">
                        <label class="control-label" for="MerchantName">Merchant Name</label>
                        <p>{{editRow.merchant}}</p>
                      </div>
                      <div class=" col-md-4">
                        <label class="control-label" for="MerchantId">Merchant Id</label>
                        <p>{{editRow.idMerchant}}</p>
                      </div>
                      <div class="col-md-4">

                        <label class="control-label" for="TerminalId">Terminal Id</label>
                        <p>{{editRow.idTerminal}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <label class="control-label" for="TerminalType">Terminal Type</label>
                        <p>{{editRow.item}}</p>
                      </div>
                      <div class=" col-md-4">
                        <label class="control-label" for="SerialKey">Serial Key</label>
                        <p>{{editRow.serialKey}}</p>
                      </div>
                      <div class="col-md-4">
                        <label class="control-label" for="Connectivity">Connectivity</label>
                        <p>{{editRow.connectivity}}</p>
                      </div>

                    </div>

                  </div>

              <div class="form-group col-md-12">
                <label class="col-sm-8"> Accessories Types <sup class="required-sign">*</sup></label>

                <select formControlName="accessoryId"
                  class="form-control col-sm-6" name="accessoryId" id="accessoryId" class="form-control "
                  [ngClass]="{ 'is-invalid': submitted && f.accessoryId.errors }" required>
                  <option *ngFor="let accessory of aaccessoryItems" [value]="accessory.accessoryId"
                    (click)="InventoryId = accessory.accessoryId;" class="drop">
                    <span>
                      {{ accessory.item }} 
                    </span>
                  </option>
                </select>
                <div *ngIf="submitted && f.accessoryId.errors" class="invalid-feedback">
                  <div *ngIf="f.accessoryId.errors.required">Accessories Type is required</div>
                </div>
              </div>
              <div class="form-group col-md-12">
                <label class="col-md-4">Branch Name<sup class="required-sign">*</sup></label>
                <div class="col-md-8">
                  <ng-autocomplete
                                [data]="bankBranches"
                                [searchKeyword]="keyword"
                                placeholder="Enter the Branch Name"
                                (selected)='bankBranchselectEvent($event)'
                                (inputChanged)='onChangeSearch($event)'
                                (inputFocused)='onFocused($event)'
                                [itemTemplate]="itemTemplate"
                                [notFoundTemplate]="notFoundTemplate"
                                [ngClass]="{'is-invalid invalid-autocomplete': submitted && f.location.errors }">
                  </ng-autocomplete>

                  <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                    <div *ngIf="f.location.errors.required"> Branch Name is required</div>
                  </div>
                  <ng-template #itemTemplate let-item>
                    <a [innerHTML]="item.branchName"> </a>
                  </ng-template>

                  <ng-template #notFoundTemplate let-notFound>
                    <div [innerHTML]="notFound"></div>
                  </ng-template>

                </div>
                </div>


          </div>
          <div class="form-group col-md-12">
            <label class="col-lg-8">Quantity <sup class="required-sign">*</sup></label>
            <input type="number" class="form-control col-sm-" min="1" max="9999" maxlength="4"
              oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 1) ? (1/0) : this.value;"
               name="requested_Quantity" id="requested_Quantity"
              placeholder="Enter requested Quantity" formControlName="requested_Quantity" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.requested_Quantity.errors }" required>
            <div *ngIf="submitted && f.requested_Quantity.errors" class="invalid-feedback">
              <div *ngIf="f.requested_Quantity.errors.required">Quantity is required</div>
            </div>

          </div>
          <br />
          <div class="form-group col-md-12">
            <button *ngIf="!isUpdating" class="btn btn-neutral" [disabled]="isDisabled" type="submit">
              <span class="spinner-border spinner-border-sm mr-1"></span>
              Submit Request
            </button>
            <!-- <button *ngIf="isUpdating" class="btn btn-neutral" type="submit">
              <span class="spinner-border spinner-border-sm mr-1"></span>
              Update Request
            </button> -->
          </div>

          </form>
        </div>

      </div>
    </div>
  </div>
  </div>
</article>
